<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="formGroup"
    onsipFormTracking
    name="admin-recording-edit"
    id="admin-recording-edit"
    class="recording-shelf-edit"
    (ngSubmit)="onSubmit()"
  >
    <div onsip-grid-placement-shelf class="recording-container">
      <div class="first-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">Name</div>
          <mat-form-field class="recording-name-field" appearance="outline">
            <input matInput type="text" formControlName="name" />
            <mat-error>{{ getNameError() }}</mat-error>
          </mat-form-field>
        </section>
      </div>
      <div class="second-column">
        <div class="mat-body-1 m-b-12">Add a recording</div>
        <div class="column button-toggle-group-container">
          <onsip-togglable-recorder
            formControlName="record"
            entityLabel="file"
            [hasSelect]="false"
            [defaultType]="greetingType"
            (recordingTypeChange)="this.greetingType = $event"
          >
          </onsip-togglable-recorder>
        </div>
      </div>
    </div>

    <div class="page-view-controls">
      <button mat-button type="button" (click)="togglePanel()" color="primary">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button mat-flat-button color="primary" type="submit">
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
